import React from 'react';

import { Typography } from '../Typography';

export type TagSize = 'default' | 'compact';
export type TagIconSize = 'sm' | 'md';

export interface TagProps {
  text: string;
  backgroundColor?: string;
  textColor?: 'default' | 'light' | 'dark' | string;
  icon?: React.ReactNode;
  size?: TagSize;
  iconSize?: TagIconSize;
  className?: string;
  onClick?: () => void;
}
export function Tag({
  text,
  backgroundColor = '#191F2E14',
  textColor = 'default',
  icon,
  size = 'default',
  iconSize = 'sm',
  className = '',
  onClick
}: TagProps) {
  const isCustomTextColor =
    textColor && !['default', 'light', 'dark'].includes(textColor);
  const sizeClasses =
    size === 'compact'
      ? 'h-[23px] gap-1 rounded-sm px-2 py-0.5'
      : 'gap-1 rounded-sm px-2 py-0.5';
  const iconSizeClass = iconSize === 'md' ? 'h-4 w-4' : 'h-3 w-3';
  const iconElement =
    icon && React.isValidElement(icon)
      ? React.cloneElement(icon as React.ReactElement<{ className?: string }>, {
          className: `${iconSizeClass} ${
            (icon as React.ReactElement<{ className?: string }>).props
              .className || ''
          }`.trim()
        })
      : icon;

  return (
    <div
      className={`inline-flex items-center ${sizeClasses} ${
        onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''
      } ${className}`}
      style={{ backgroundColor }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }>
      {iconElement && <span className="flex items-center">{iconElement}</span>}
      <Typography
        variant="metadata-sm-regular"
        color={
          isCustomTextColor
            ? undefined
            : (textColor as 'default' | 'light' | 'dark')
        }
        className="whitespace-nowrap"
        style={isCustomTextColor ? { color: textColor } : undefined}>
        {text}
      </Typography>
    </div>
  );
}
